import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";

import {
  CompleteRequestAPICall,
  GetModificationRequestEmailMobileAPICall,
  GetProfileDetailsEmailMobileAPICall,
  GetStageDetailsAPICall,
  resetEmailAPICall,
  resetMobileAPICall,
  ValidationEmailOTPAPICall,
  ValidationMobileOTPAPICall,
} from "../EmailMobileUpdateAPICalls";
import EditIcon from "@mui/icons-material/Edit";

import BankStyles from "./Profile.module.scss";

import image from "../../../Components/assets/Images/bankupdateicon.svg";
import { APPID, ENV,  TOKENNAME } from "../../../shared/constants";
import { browserName } from "react-device-detect";
import { getCookie } from "../cookies";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import UpdateMobileEmailModal from "../UpdateMobileEmailModal/UpdateMobileEmailModal";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import keyboardicon from "../../../Components/assets/Images/panicongrey.svg";
import { GetProfileDetailsCommonAPICall } from "../../../shared/APICalls";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const successModalStyles = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  height: "100vh",
  transform: "translate(-50%, -50%)",
  margin: "auto",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "40px 30px",
  outline: "none",
  display: "flex",
};

export default function EmailMobileProfileDetails() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const params: any = Object.fromEntries(urlParams.entries());
  const pathName = useLocation().pathname;
  const [successMessage, setsuccessMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [userData, setUserData] = useState<any>();
  const [errorMessage, seterrorMessage] = useState("");
  const [rejectMessage, setrejectMessage] = useState("");
  const [modificationData, setmodificationData] = useState([]);
  const callBackURL = document.location.href;
  const [openUpdateModal, setOpenUpdateModal] = useState({
    status: false,
    data: "",
    values: "",
  });
  const [requestID, setRequestID] = useState("");
  const [stageDetails, setStageDetails] = useState({
    mobile: "",
    email: "",
    client_code: "",
    full_name: "",
    is_email_verified: false,
    is_mobile_verified: false,
    is_rejected: false,
    request_id: "",
  });

  const cookieData = getCookie(TOKENNAME);
  // const cookieData =
  //  "finupdate_token=hXNbRSme3OU0DQeVUYzfyiQNYtgn1s/rXYSnCSQbsViZ0AXTS2Ms4t9OWiUScT/NMl/IidLVd+c1YPbPwz0pYGWjwI7+wfkemEuYWPC0taIB8GgWbOkaFPTaexIDJHlDxx6otF9SxJwJ8xPYctSLzjmq/RpPzg5p14m6c0NFOII=";
  const userId = getCookie("userId");
  // const userId = "KC1593";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    GetProfileDetails();
    GetStageDetails();
  }, [cookieData]);

  const GetProfileDetails = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        //  console.log("GetProfileDetails", response.data.data.data);
        if (response.data?.data?.data) {
          setUserData(response.data.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const GetStageDetails = () => {
    let obj: any = {
      request_id: null,
      stage: "dashboard",
    };
    GetStageDetailsAPICall(obj)
      .then((response: any) => {
        //  console.log("stageResponse", response.data.data);
        if (response.data.data) {
          setStageDetails(response.data.data);
          setRequestID(response.data.data.request_id);
          sessionStorage.setItem("emrequestid", response.data.data.request_id);

          if (response.data.data.ErrMessage) {
            setrejectMessage(response.data.data.ErrMessage);
          }
          if (response.data.data.next_stage !== "profile_details") {
            navigate(`/emailandmobileupdate/${response.data.data.next_stage}`);
          }
        }
      })
      .catch((error: any) => {});
  };

  const handleOpenUpdateModel = (datatype: any, value: any) => {
    setOpenUpdateModal({
      status: true,
      data: datatype,
      values: value,
    });
  };

  const handleCloseUpdateModel = () => {
    setOpenUpdateModal({
      status: false,
      data: "",
      values: "",
    });
  };

  const handleSubmitData = (values: any, type: any, requestId: any) => {
    if (type === "email") {
      let obj: any = {
        request_id: sessionStorage.getItem("emrequestid"),
        email: values.email,
        otp: values.otp,
      };

      // console.log("obj", obj);
      ValidationEmailOTPAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          setOpenUpdateModal({
            status: false,
            data: "",
            values: "",
          });
          setsuccessMessage("Successfully Updated");
          setRequestID(requestId);
          GetStageDetails();

          setTimeout(() => {
            setsuccessMessage("");
          }, 5000);
        })
        .catch((error: any) => {
          if (error && error.response.data.message) {
            seterrorMessage(error.response.data.message);
            setTimeout(() => {
              seterrorMessage("");
            }, 5000);
          }
        });
    } else {
      //  console.log("mobileValues", values);
      let obj: any = {
        request_id: sessionStorage.getItem("emrequestid"),
        mobile: values.mobile,
        otp: values.otp,
      };
      ValidationMobileOTPAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          setOpenUpdateModal({
            status: false,
            data: "",
            values: "",
          });
          setsuccessMessage("Successfully Updated");
          setRequestID(requestId);
          GetStageDetails();
          setTimeout(() => {
            setsuccessMessage("");
          }, 5000);
        })
        .catch((error: any) => {
          if (error && error.response.data.message) {
            seterrorMessage(error.response.data.message);
            setTimeout(() => {
              seterrorMessage("");
            }, 5000);
          }
        });
    }
  };

  const handleNext = () => {
    const NewRequestID: any = sessionStorage.getItem("emrequestid");
    let obj: any = {
      request_id: requestID ? requestID : NewRequestID,
    };

    CompleteRequestAPICall(obj)
      .then((response: any) => {
        //  console.log("completeresponse", response.data.data);

        if (response.data.data.next_stage) {
          navigate(`/emailandmobileupdate/${response.data.data.next_stage}`);
        }
      })
      .catch((error: any) => {});
  };

  const ResetEmail = () => {
    let obj: any = {
      request_id: stageDetails.request_id,
    };
    resetEmailAPICall(obj).then((response: any) => {
      GetStageDetails();
      setsuccessMessage("Successfully reseted");
      setTimeout(() => {
        setsuccessMessage("");
      }, 5000);
    });
  };
  const ResetMobile = () => {
    let obj: any = {
      request_id: stageDetails.request_id,
    };
    resetMobileAPICall(obj).then((response: any) => {
      GetStageDetails();
      setsuccessMessage("Successfully reseted");
      setTimeout(() => {
        setsuccessMessage("");
      }, 5000);
    });
  };

  const filteredMobileUpdates: any = modificationData?.filter(
    (a: any) => a.category === "mobile"
  );
  const filteredEmailUpdates: any = modificationData?.filter(
    (a: any) => a.category === "email"
  );

  const FilteredModifiedData = modificationData?.filter(
    (a: any) => a.status !== "PROGRESS"
  );

  const ProgressEmialData = modificationData?.filter(
    (a: any) => a.status === "PROGRESS" && a.category === "email"
  );
  const ProgressMobileData = modificationData?.filter(
    (a: any) => a.status === "PROGRESS" && a.category === "mobile"
  );

  return (
    <>
      {" "}
      <SucessSnackBar message={successMessage} />
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={BankStyles.mainWrapper}>
        <div className={BankStyles.wrapper}>
          <div className={BankStyles.step}>
            <img src={keyboardicon} /> Step 1 of 3
          </div>

          <div>
            <p className={BankStyles.Header}>Profile Details</p>
          </div>
          <p className={BankStyles.subText}>Confirm your profile information</p>
          <div className={BankStyles.txtwrapper}>
          <Grid
            container
            rowSpacing={5}
            columnSpacing={{ xs: 1, sm: 2, md: 5 }}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  style: { color: "#111827", fontWeight: 500 },
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                }}
                id="outlined-basic"
                label="Email"
                variant="outlined"
                value={stageDetails?.email}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {stageDetails?.is_email_verified === true ||
                      stageDetails?.is_rejected === true ? (
                        ""
                      ) : (
                        <Tooltip title="Update Email">
                          <Button
                            variant="text"
                            disableFocusRipple
                            disableTouchRipple
                            sx={{
                              height: "25px",
                              "&:hover": { background: "transparent" },
                            }}
                            size="small"
                            onClick={() => {
                              handleOpenUpdateModel(
                                "email",
                                stageDetails?.email
                              );
                            }}
                            disabled={
                              filteredEmailUpdates?.length > 0 &&
                              filteredEmailUpdates[
                                filteredEmailUpdates?.length - 1
                              ]?.status === "PENDING"
                                ? true
                                : false
                            }
                          >
                            <EditIcon
                              sx={{ fontSize: "16px", color: "grey" }}
                            />
                          </Button>
                        </Tooltip>
                      )}
                      {/* {stageDetails?.new_email && (
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#006779",
                            height: "30px",
                            marginLeft: "10px",
                          }}
                          onClick={ResetEmail}
                        >
                          Reset
                        </Button>
                      )} */}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  style: { color: "#111827", fontWeight: 500 },
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                }}
                id="outlined-basic"
                label="Mobile"
                variant="outlined"
                value={stageDetails?.mobile}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {stageDetails?.is_mobile_verified === true ||
                      stageDetails?.is_rejected === true ? (
                        ""
                      ) : (
                        <Tooltip title="Update Mobile Number">
                          <Button
                            variant="text"
                            disableFocusRipple
                            disableTouchRipple
                            sx={{
                              height: "25px",
                              "&:hover": { background: "transparent" },
                            }}
                            size="small"
                            onClick={() => {
                              handleOpenUpdateModel(
                                "mobile",
                                stageDetails?.mobile
                              );
                            }}
                            disabled={
                              filteredMobileUpdates?.length > 0 &&
                              filteredMobileUpdates[
                                filteredMobileUpdates.length - 1
                              ]?.status === "PENDING"
                                ? true
                                : false
                            }
                          >
                            <EditIcon
                              sx={{ fontSize: "16px", color: "grey" }}
                            />
                          </Button>
                        </Tooltip>
                      )}
                      {/* {stageDetails?.new_mobile && (
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#006779",
                            height: "30px",
                            marginLeft: "10px",
                          }}
                          onClick={ResetMobile}
                        >
                          Reset
                        </Button>
                      )} */}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  style: { color: "#111827", fontWeight: 500 },
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                }}
                id="outlined-basic"
                label="Client Code"
                variant="outlined"
                value={stageDetails?.client_code}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  style: { color: "#111827", fontWeight: 500 },
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                }}
                id="outlined-basic"
                label="Full Name"
                variant="outlined"
                value={stageDetails?.full_name}
              />
            </Grid>
          </Grid>
          </div>

          <div className={BankStyles.buttonStack}>
            <LoadingButton
              loading={loading}
              disabled={
                stageDetails?.is_email_verified === false &&
                stageDetails?.is_mobile_verified === false
              }
              variant="contained"
              type="submit"
              id="linkUsingIFSCContinueButton"
              className={BankStyles.approveButton}
              sx={{
                textTransform: "uppercase",
                fontSize: "12px",
         
                width: "200px",
                height: "50px",
              }}
              onClick={handleNext}
            >
              Continue
            </LoadingButton>
          </div>
        </div>
        {openUpdateModal.status && (
          <UpdateMobileEmailModal
            open={openUpdateModal.status}
            handleClose={handleCloseUpdateModel}
            handleSubmitData={handleSubmitData}
            data={openUpdateModal.data}
            value={stageDetails.request_id}
            ProgressEmialData={ProgressEmialData}
            ProgressMobileData={ProgressMobileData}
          />
        )}
      </div>
      {FilteredModifiedData?.length > 0 && (
        <div className={BankStyles.updateStatus}>
          <p className={BankStyles.recentModifiedText}>Recent Modification</p>

          <div className={BankStyles.tableWrapper}>
            <div className={BankStyles.header}>
              <div className={BankStyles.headerCellCategory}>Category</div>

              <div className={BankStyles.headerCelllastUpdate}>
                Last Updated
              </div>
              <div className={BankStyles.headerCellAction}>Descripition</div>
              <div className={BankStyles.headerCellStatus}>Status</div>
            </div>

            <div className={BankStyles.dataContainer}>
              {FilteredModifiedData?.map((a: any) => (
                <div className={BankStyles.tableData}>
                  <div className={BankStyles.dataCellCategory}>
                    {a.category?.toUpperCase()}
                  </div>
                  <div className={BankStyles.dataCelllastUpdate}>
                    {a.lastUpdatedTS?.slice(0, 10)}
                  </div>

                  <div className={BankStyles.dataCellAction}>
                    {a.status === "PENDING"
                      ? "Modification request is in Progress"
                      : a.status === "APPROVED"
                      ? "Modification request is Successfull"
                      : a.rejectedReason
                      ? a.rejectedReason
                      : "-"}
                  </div>
                  <div
                    className={BankStyles.dataCellStatus}
                    style={{
                      color:
                        a.status === "APPROVED"
                          ? "#00C8AF"
                          : a.status === "REJECTED"
                          ? "#FF6B6B"
                          : "#05aef5",
                    }}
                  >
                    {a.status}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {FilteredModifiedData.length > 0 && (
        <div className={BankStyles.updateStatusMobile}>
          <p className={BankStyles.recentModifiedText}>Recent Modification</p>
          {FilteredModifiedData?.map((a: any) => (
            <div className={BankStyles.updateStatusMobileContent}>
              <div className={BankStyles.mobileDiv}>
                <p className={BankStyles.mobileDivHeader}>Category :</p>
                <p className={BankStyles.mobileDivContent}>{a.category}</p>
              </div>

              <div className={BankStyles.mobileDiv}>
                <p className={BankStyles.mobileDivHeader}>Last Updated :</p>
                <p className={BankStyles.mobileDivContent}>
                  {" "}
                  {a.lastUpdatedTS?.slice(0, 10)}
                </p>
              </div>
              <div className={BankStyles.mobileDiv}>
                <p className={BankStyles.mobileDivHeader}>Status :</p>
                <p
                  className={BankStyles.mobileDivContent}
                  style={{
                    color:
                      a.status === "APPROVED"
                        ? "#00C8AF"
                        : a.status === "REJECTED"
                        ? "#FF6B6B"
                        : "#05aef5",
                  }}
                >
                  {a.status}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
